import { useCallback, useContext } from "react";
import dayjs from "dayjs";
import { Modal } from "react-overlays";
import OsteopataContext from "../../context/osteopata";
import Icon from "../icon";
import useOsteopathCancelMutation from "../../hooks/mutations/useOsteopathCancelMutation";

const renderBackdrop = (props) => <div className="backdrop" {...props} />;

const OsteopataCancelAppointmentModal = ({ modal, setModal, request, setCancelledToast }) => {
  const { labels, appLang } = useContext(OsteopataContext);
  const closeModal = () => setModal(false);

  const { mutateAsync: cancelAppointment, isError } = useOsteopathCancelMutation(closeModal);

  const handleCancelRequest = useCallback(async () => {
    await cancelAppointment({ requestId: request?.id });
    setCancelledToast(request);
  }, [cancelAppointment, request, setCancelledToast]);

  return (
    <Modal
      show={!!modal}
      onHide={closeModal}
      aria-labelledby="modal-label"
      className="modal modal--borse dark-mode"
      renderBackdrop={renderBackdrop}
      onBackdropClick={closeModal}
      aria-hidden="false"
      aria-modal="true"
    >
      <>
        <button
          type="button"
          onClick={closeModal}
          className="close-button"
          aria-label={labels?.CLOSE}
        >
          <Icon name="cross" />
        </button>
        <div className="modal__body wrapper">
          <h1 className="modal__title">
            {(
              labels?.WELFARE_OSTEOPATA_CANCEL_MODAL_TITLE ||
              "Vuoi disdire l'appuntamento del [DATE]?"
            ).replace(
              "[DATE]",
              dayjs(Number(request?.bookingDate))
                .locale(appLang?.value || "it")
                .format("L")
            )}
          </h1>
          <div className="modal__buttons">
            <button className="button secondary" onClick={closeModal}>
              {labels?.WELFARE_OSTEOPATA_NO || "No"}
            </button>
            <button className="button primary" onClick={handleCancelRequest}>
              {labels?.WELFARE_OSTEOPATA_YES_CANCEL || "Sì, disdici"}
              <Icon name="calendar-xmark" />
            </button>
          </div>
          {isError && (
            <p className="modal__error">
              {labels?.WELFARE_OSTEOPATA_ERROR_CANCELING_REQUEST || "Error discarding request"}
            </p>
          )}
        </div>
      </>
    </Modal>
  );
};

export default OsteopataCancelAppointmentModal;
